export default Marionette.CollectionView.extend({
    className: 'carousel__content'
});
